import React from 'react';

/**
 * Horizontal, scrollable section tabs for the help drawer.
 */
export default function HelpNav({ sections, activeSection, onSectionChange }) {
  return (
    <div className="help-nav" role="tablist" aria-label="Help sections">
      {sections.map((section) => (
        <button
          key={section.id}
          type="button"
          role="tab"
          aria-selected={activeSection === section.id}
          className={`help-tab ${activeSection === section.id ? 'is-active' : ''}`}
          onClick={() => onSectionChange(section.id)}
        >
          <i className={`${section.icon} me-1`} aria-hidden="true" />
          <span>{section.title}</span>
        </button>
      ))}
    </div>
  );
}
